import Crud from '../views/Establishment/Crud'
import Entity from '../views/Establishment/Add'

let routes = {
    path: '/establishments',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/establishments/add',
            name: 'NewEstablishment',
            component: Entity,
            meta: {
                pageTitle: 'Estabelecimento',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Adicionar Estabelecimento',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/establishments/edit/:id?',
            name: 'EditEstablishment',
            component: Entity,
            meta: {
                pageTitle: 'Estabelecimento',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Editar Estabelecimento',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/establishments',
            name: 'list-establishments',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Estabelecimentos',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Estabelecimentos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
